// extracted by mini-css-extract-plugin
module.exports = {"text":"o3vtEV"};